import React, { useEffect, useMemo, useState } from "react";
import { NavLink, Outlet, Link, useLocation } from "react-router-dom";

function NavItem({ to, end, children }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) =>
        [
          "flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-medium transition",
          isActive
            ? "bg-amber-100 text-slate-900 shadow-sm"
            : "text-slate-600 hover:bg-amber-50",
        ].join(" ")
      }
    >
      {children}
    </NavLink>
  );
}

export default function OrganizerLayout() {
  const { pathname } = useLocation();
  const [mobileNav, setMobileNav] = useState(false);

  const user = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem("bb_user") || "null");
    } catch {
      return null;
    }
  }, []);

  const isAdmin = String(user?.role || "").toLowerCase() === "admin";

  useEffect(() => {
    setMobileNav(false);
  }, [pathname]);

  useEffect(() => {
    const prev = document.body.style.overflow;
    if (mobileNav) document.body.style.overflow = "hidden";
    else document.body.style.overflow = prev || "";
    return () => {
      document.body.style.overflow = prev || "";
    };
  }, [mobileNav]);

  return (
    <div className="min-h-[calc(100vh-3.5rem)] bg-[#faf8f5]">
      <div className="mx-auto max-w-7xl flex flex-col lg:flex-row gap-0 lg:gap-6 px-3 sm:px-4 py-4">
        {/* Mobile bar */}
        <div className="lg:hidden flex items-center justify-between gap-2 mb-3 rounded-xl border border-amber-100 bg-white px-3 py-2 shadow-sm">
          <span className="text-sm font-semibold text-slate-800">Organizer</span>
          <button
            type="button"
            className="rounded-lg border px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-amber-50"
            onClick={() => setMobileNav((v) => !v)}
            aria-expanded={mobileNav}
          >
            Menu
          </button>
        </div>

        {/* Sidebar */}
        <aside
          className={[
            "lg:w-56 shrink-0 rounded-xl border border-amber-100 bg-white p-3 shadow-sm h-fit lg:sticky lg:top-24",
            mobileNav ? "block" : "hidden lg:block",
          ].join(" ")}
          aria-label="Organizer navigation"
        >
          <div className="px-1 pb-2 mb-2 border-b border-slate-100">
            <div className="text-[11px] font-semibold uppercase tracking-wide text-amber-800/90">
              Organization console
            </div>
            <p className="text-xs text-slate-500 mt-0.5 leading-snug">
              Create and manage your live events, tickets, and payouts-related tasks from here.
            </p>
          </div>
          <nav className="flex flex-col gap-1">
            <NavItem to="/listyourshow" end>
              My events
            </NavItem>
            <NavItem to="/listyourshow/new">New event</NavItem>
            <Link
              to="/"
              className="rounded-lg px-3 py-2 text-sm font-medium text-slate-600 hover:bg-amber-50"
            >
              ← Public website
            </Link>
            {isAdmin && (
              <NavLink
                to="/admin"
                className={({ isActive }) =>
                  [
                    "rounded-lg px-3 py-2 text-sm font-medium transition",
                    isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-100",
                  ].join(" ")
                }
              >
                Site admin panel
              </NavLink>
            )}
          </nav>
        </aside>

        {/* Main */}
        <div className="flex-1 min-w-0 rounded-xl border border-amber-100/80 bg-white shadow-sm p-4 sm:p-5 md:p-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
